import React from "react";
import { CLIENT_TYPE, ClientConfig } from "../api";
import { ClientConfigContext } from "./ClientConfigContext";
import { makeRequestInternal } from "./AccountProvider";
import { RetryContext } from "./RetryContext";
import { useLoadingIndicator } from "./LoadingIndicatorContext";

interface Props {
  children: React.ReactNode;
}
export const ClientConfigProvider = (props: Props) => {
  const [clientConfig, setClientConfig] = React.useState<ClientConfig | null>(
    null
  );
  const { showRetry } = React.useContext(RetryContext);
  const { stopLoading } = useLoadingIndicator(true);

  React.useEffect(() => {
    const clientConfigUrl =
      window.location.origin.replace(
        /^https:\/\/(.*)superteacherapp.com/,
        "https://$1getsuperteacher.com"
      ) +
      "/api/client-config/?timestamp=" +
      new Date().getTime();
    makeRequestInternal(clientConfigUrl, "GET", showRetry, showRetry).then(
      (response) => {
        setClientConfig(response.body);
        stopLoading();
      }
    );
  }, [showRetry, stopLoading]);

  const contextValue = React.useMemo(
    () => ({
      clientConfig: clientConfig as ClientConfig,
      webSocketUrl: () => {
        return (
          clientConfig!.api_base_url.replace("https", "wss") +
          "sserver/" +
          CLIENT_TYPE +
          "/"
        );
      },

      privacyPolicyUrl: () => {
        return clientConfig!.page_base_url + "privacy-policy/";
      },

      termsOfUseUrl: () => {
        return clientConfig!.page_base_url + "terms-of-use/";
      },

      staticUrl: () => {
        return clientConfig!.api_base_url + "static/";
      },
    }),
    [clientConfig]
  );

  return clientConfig ? (
    <ClientConfigContext.Provider value={contextValue}>
      {props.children}
    </ClientConfigContext.Provider>
  ) : (
    <></>
  );
};
